<template>
  <Overview />
</template>

<script>
  import Overview from './index';
  export default {
    name: 'supplierContract',
    components: {
      Overview,
    },
  };
</script>
